var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 11h-6.3c.5-.7.8-1.6.8-2.6 0-2.4-2-4.4-4.4-4.4-1.4 0-2.7.7-3.5 1.7-.8-1.1-2-1.7-3.4-1.7-2.4 0-4.4 2-4.4 4.4v.1c0 1 .3 1.8.8 2.6H6.7C5.2 11 4 12.3 4 13.7v3.1c0 1.2.8 2.2 1.8 2.5v14.1c0 1.5 1.2 2.7 2.7 2.7h23.1c1.5 0 2.7-1.2 2.7-2.7V19.3c1.1-.3 1.8-1.4 1.8-2.5v-3.1c0-1.5-1.3-2.7-2.7-2.7zm.9 5.8c0 .5-.4.9-.9.9h-9.6v-4.8h9.6c.5 0 .9.4.9.9v3zm-1.8 16.6c0 .5-.4.9-.9.9h-7.7V19.4h8.7l-.1 14zm-24.9 0v-14h8.7v14.9H8.5c-.5 0-.9-.4-.9-.9zm10.4.9V19.4h4v14.9h-4zM5.8 16.8v-3.1c0-.5.4-.9.9-.9h9.6v4.8H6.7c-.5 0-.9-.4-.9-.8zm16.3-4v4.8h-4v-4.8h4zm-1.2-4.4c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6v.1c0 1.4-1.2 2.6-2.6 2.6h-2.6V8.4zm-6.9 0c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6V11h-2.6C15.1 11 14 9.9 14 8.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift2);
export default __webpack_public_path__ + "static/media/gift-2.69ddbfae.svg";
export { ForwardRef as ReactComponent };